/** CoStar.Attachment.Entities.ImageSize */
export var ImageSize;
(function (ImageSize) {
    ImageSize[ImageSize["Unknown"] = 0] = "Unknown";
    ImageSize[ImageSize["Master"] = 1] = "Master";
    /** @deprecated Please use H140W180. */
    ImageSize[ImageSize["Small"] = 4] = "Small";
    /** @deprecated Please use H110W215. */
    ImageSize[ImageSize["Thumbnail"] = 5] = "Thumbnail";
    /** @deprecated Please use H206W337. */
    ImageSize[ImageSize["Edit"] = 6] = "Edit";
    /** @deprecated Please use an alternative value. */
    ImageSize[ImageSize["Enlarge"] = 7] = "Enlarge";
    /** @deprecated Please use H588W984. */
    ImageSize[ImageSize["Large"] = 10] = "Large";
    /** @deprecated Please use H844W1240. */
    ImageSize[ImageSize["ExtraLarge"] = 11] = "ExtraLarge";
    /** @deprecated Please use H900W1800. */
    ImageSize[ImageSize["HighDefinition"] = 12] = "HighDefinition";
    /** @deprecated Please use H720W1400. */
    ImageSize[ImageSize["Widescreen"] = 13] = "Widescreen";
    /** @deprecated Please use H1024W1024. */
    ImageSize[ImageSize["GoLarge"] = 14] = "GoLarge";
    /** @deprecated Please use HVariableW325. */
    ImageSize[ImageSize["GoDetail"] = 15] = "GoDetail";
    /** @deprecated Please use H2048W2048. */
    ImageSize[ImageSize["GoLargeHighDefinition"] = 16] = "GoLargeHighDefinition";
    /** @deprecated Please use HVariableW650. */
    ImageSize[ImageSize["GoDetailHighDefinition"] = 17] = "GoDetailHighDefinition";
    /** @deprecated Please use H220W430. */
    ImageSize[ImageSize["GoThumbnailHighDefinition"] = 18] = "GoThumbnailHighDefinition";
    /** @deprecated Please use HVariableW200. */
    ImageSize[ImageSize["FusionDetailSmall"] = 19] = "FusionDetailSmall";
    ImageSize[ImageSize["H658W984"] = 102] = "H658W984";
    /** @deprecated Please use the non-duplicate version. */
    ImageSize[ImageSize["H658W984Duplicate"] = 103] = "H658W984Duplicate";
    ImageSize[ImageSize["H140W180"] = 104] = "H140W180";
    ImageSize[ImageSize["H110W215"] = 105] = "H110W215";
    /** @deprecated Please use H206W337. */
    ImageSize[ImageSize["H210W315"] = 106] = "H210W315";
    ImageSize[ImageSize["H206W337"] = 106] = "H206W337";
    ImageSize[ImageSize["H588W984"] = 110] = "H588W984";
    ImageSize[ImageSize["H844W1240"] = 111] = "H844W1240";
    ImageSize[ImageSize["H900W1800"] = 112] = "H900W1800";
    ImageSize[ImageSize["H720W1400"] = 113] = "H720W1400";
    ImageSize[ImageSize["H1024W1024"] = 114] = "H1024W1024";
    ImageSize[ImageSize["HVariableW325"] = 115] = "HVariableW325";
    ImageSize[ImageSize["H2048W2048"] = 116] = "H2048W2048";
    ImageSize[ImageSize["HVariableW650"] = 117] = "HVariableW650";
    ImageSize[ImageSize["H220W430"] = 118] = "H220W430";
    ImageSize[ImageSize["HVariableW200"] = 119] = "HVariableW200";
})(ImageSize || (ImageSize = {}));
/** CoStar.Attachment.Entities.AttachmentType */
export var AttachmentType;
(function (AttachmentType) {
    AttachmentType[AttachmentType["Unknown"] = 0] = "Unknown";
    AttachmentType[AttachmentType["Aerial"] = 1] = "Aerial";
    AttachmentType[AttachmentType["Financial"] = 2] = "Financial";
    AttachmentType[AttachmentType["PrimaryPhoto"] = 3] = "PrimaryPhoto";
    AttachmentType[AttachmentType["BuildingPhoto"] = 4] = "BuildingPhoto";
    AttachmentType[AttachmentType["VirtualTour"] = 5] = "VirtualTour";
    AttachmentType[AttachmentType["Lobby"] = 6] = "Lobby";
    AttachmentType[AttachmentType["Other"] = 7] = "Other";
    AttachmentType[AttachmentType["MarketingBrochure"] = 8] = "MarketingBrochure";
    AttachmentType[AttachmentType["PlatMap"] = 9] = "PlatMap";
    AttachmentType[AttachmentType["FloorPlan"] = 10] = "FloorPlan";
    AttachmentType[AttachmentType["SitePlan"] = 11] = "SitePlan";
    AttachmentType[AttachmentType["TypicalFloorPlan"] = 12] = "TypicalFloorPlan";
    AttachmentType[AttachmentType["Slate"] = 13] = "Slate";
    AttachmentType[AttachmentType["PrimaryContactPhoto"] = 14] = "PrimaryContactPhoto";
    AttachmentType[AttachmentType["Logo"] = 15] = "Logo";
    AttachmentType[AttachmentType["Map"] = 16] = "Map";
    AttachmentType[AttachmentType["SmallImage"] = 17] = "SmallImage";
    AttachmentType[AttachmentType["LargeImage"] = 18] = "LargeImage";
    AttachmentType[AttachmentType["TenantPhoto"] = 19] = "TenantPhoto";
    AttachmentType[AttachmentType["LeaseDocument"] = 20] = "LeaseDocument";
    AttachmentType[AttachmentType["PublicFiling"] = 21] = "PublicFiling";
    AttachmentType[AttachmentType["Deed"] = 22] = "Deed";
    AttachmentType[AttachmentType["TransferTaxDeclaration"] = 23] = "TransferTaxDeclaration";
    AttachmentType[AttachmentType["PropertyRecordCard"] = 24] = "PropertyRecordCard";
    AttachmentType[AttachmentType["RentAndLeaseAssignment"] = 25] = "RentAndLeaseAssignment";
    AttachmentType[AttachmentType["Loan"] = 26] = "Loan";
    AttachmentType[AttachmentType["Article"] = 27] = "Article";
    AttachmentType[AttachmentType["PressRelease"] = 28] = "PressRelease";
    AttachmentType[AttachmentType["SecuritiesExchangeCommissionFiling"] = 29] = "SecuritiesExchangeCommissionFiling";
    AttachmentType[AttachmentType["CompanyReport"] = 30] = "CompanyReport";
    AttachmentType[AttachmentType["MediaSource"] = 31] = "MediaSource";
    AttachmentType[AttachmentType["DirectoryPhoto"] = 32] = "DirectoryPhoto";
    AttachmentType[AttachmentType["InteriorPhoto"] = 33] = "InteriorPhoto";
    AttachmentType[AttachmentType["GoadMap"] = 34] = "GoadMap";
    AttachmentType[AttachmentType["CommunityBrochure"] = 35] = "CommunityBrochure";
    AttachmentType[AttachmentType["PlacardLogo"] = 36] = "PlacardLogo";
    AttachmentType[AttachmentType["PropertyLogo"] = 37] = "PropertyLogo";
    AttachmentType[AttachmentType["ConstructionPhoto"] = 38] = "ConstructionPhoto";
    AttachmentType[AttachmentType["ReinforcingAdvertisement"] = 39] = "ReinforcingAdvertisement";
    /** @deprecated Please use 'ProVideoApartments' instead. */
    AttachmentType[AttachmentType["ProVideo"] = 40] = "ProVideo";
    AttachmentType[AttachmentType["ProVideoApartments"] = 40] = "ProVideoApartments";
    AttachmentType[AttachmentType["CityPhoto"] = 41] = "CityPhoto";
    AttachmentType[AttachmentType["NeighborhoodPhoto"] = 42] = "NeighborhoodPhoto";
    AttachmentType[AttachmentType["ThreeDimensionalScan"] = 43] = "ThreeDimensionalScan";
    AttachmentType[AttachmentType["ProVideoApartmentFinder"] = 44] = "ProVideoApartmentFinder";
    AttachmentType[AttachmentType["ConfidentialityAgreement"] = 45] = "ConfidentialityAgreement";
    AttachmentType[AttachmentType["ProVideoApartamentos"] = 46] = "ProVideoApartamentos";
    AttachmentType[AttachmentType["CommercialListingVideo"] = 47] = "CommercialListingVideo";
    AttachmentType[AttachmentType["MarketingLogo"] = 48] = "MarketingLogo";
    AttachmentType[AttachmentType["ProVideoLoopNet"] = 49] = "ProVideoLoopNet";
    AttachmentType[AttachmentType["State"] = 50] = "State";
    AttachmentType[AttachmentType["County"] = 51] = "County";
    AttachmentType[AttachmentType["MilitaryBase"] = 52] = "MilitaryBase";
    AttachmentType[AttachmentType["CollegeUniversity"] = 53] = "CollegeUniversity";
    AttachmentType[AttachmentType["ArticleVideo"] = 54] = "ArticleVideo";
    AttachmentType[AttachmentType["AerialVideo"] = 55] = "AerialVideo";
    AttachmentType[AttachmentType["ThermalVideo"] = 56] = "ThermalVideo";
    AttachmentType[AttachmentType["UavVideo"] = 57] = "UavVideo";
    AttachmentType[AttachmentType["ProVideoForRent"] = 58] = "ProVideoForRent";
    AttachmentType[AttachmentType["PlacardPrimaryPhoto"] = 59] = "PlacardPrimaryPhoto";
    AttachmentType[AttachmentType["ShortUavVideo"] = 60] = "ShortUavVideo";
    AttachmentType[AttachmentType["PlacardLogoVector"] = 61] = "PlacardLogoVector";
    AttachmentType[AttachmentType["CoStarPlaneView"] = 62] = "CoStarPlaneView";
    /** @deprecated Please use 'DesktopCoverPhotoResidential' instead. */
    AttachmentType[AttachmentType["ProfileCoverDesktop"] = 63] = "ProfileCoverDesktop";
    AttachmentType[AttachmentType["DesktopCoverPhotoResidential"] = 63] = "DesktopCoverPhotoResidential";
    AttachmentType[AttachmentType["PlacardHighlightPhoto"] = 64] = "PlacardHighlightPhoto";
    AttachmentType[AttachmentType["PlacardHighlightVideo"] = 65] = "PlacardHighlightVideo";
    AttachmentType[AttachmentType["AmenityPhoto"] = 66] = "AmenityPhoto";
    AttachmentType[AttachmentType["AmenityVideo"] = 67] = "AmenityVideo";
    /** @deprecated Please use 'MobileCoverPhotoResidential' instead. */
    AttachmentType[AttachmentType["ProfileCoverMobile"] = 68] = "ProfileCoverMobile";
    AttachmentType[AttachmentType["MobileCoverPhotoResidential"] = 68] = "MobileCoverPhotoResidential";
    AttachmentType[AttachmentType["DesktopCoverPhotoCommercial"] = 69] = "DesktopCoverPhotoCommercial";
    AttachmentType[AttachmentType["MobileCoverPhotoCommercial"] = 70] = "MobileCoverPhotoCommercial";
    AttachmentType[AttachmentType["LandRegistry"] = 71] = "LandRegistry";
    AttachmentType[AttachmentType["CollegeLogo"] = 72] = "CollegeLogo";
    AttachmentType[AttachmentType["TenantExternalPhoto"] = 73] = "TenantExternalPhoto";
    AttachmentType[AttachmentType["TenantInternalPhoto"] = 74] = "TenantInternalPhoto";
    AttachmentType[AttachmentType["PylonPhoto"] = 75] = "PylonPhoto";
    AttachmentType[AttachmentType["StockPhoto"] = 76] = "StockPhoto";
    AttachmentType[AttachmentType["CoverPagePhoto"] = 77] = "CoverPagePhoto";
    AttachmentType[AttachmentType["SpaceManagerPhoto"] = 78] = "SpaceManagerPhoto";
    AttachmentType[AttachmentType["ResidentialListingVideo"] = 79] = "ResidentialListingVideo";
    AttachmentType[AttachmentType["OfferingMemorandum"] = 80] = "OfferingMemorandum";
    AttachmentType[AttachmentType["BrandExteriorPhoto"] = 81] = "BrandExteriorPhoto";
    AttachmentType[AttachmentType["BrandInteriorPhoto"] = 82] = "BrandInteriorPhoto";
    AttachmentType[AttachmentType["NeighborhoodVideo"] = 83] = "NeighborhoodVideo";
    AttachmentType[AttachmentType["NeighborhoodVideoClip"] = 84] = "NeighborhoodVideoClip";
    AttachmentType[AttachmentType["ParkVideo"] = 85] = "ParkVideo";
    AttachmentType[AttachmentType["ParkVideoClip"] = 86] = "ParkVideoClip";
    AttachmentType[AttachmentType["SchoolVideo"] = 87] = "SchoolVideo";
    AttachmentType[AttachmentType["SchoolVideoClip"] = 88] = "SchoolVideoClip";
    AttachmentType[AttachmentType["CondoBuildingVideo"] = 89] = "CondoBuildingVideo";
    AttachmentType[AttachmentType["CondoBuildingVideoClip"] = 90] = "CondoBuildingVideoClip";
    AttachmentType[AttachmentType["VideoProjectFile"] = 91] = "VideoProjectFile";
    AttachmentType[AttachmentType["AudioFile"] = 92] = "AudioFile";
    AttachmentType[AttachmentType["ProductionScript"] = 93] = "ProductionScript";
    AttachmentType[AttachmentType["ParkPhoto"] = 94] = "ParkPhoto";
    AttachmentType[AttachmentType["SchoolPhoto"] = 95] = "SchoolPhoto";
    AttachmentType[AttachmentType["CaseDocument"] = 96] = "CaseDocument";
    AttachmentType[AttachmentType["ViewFromUnit"] = 97] = "ViewFromUnit";
    AttachmentType[AttachmentType["AgentVideo"] = 98] = "AgentVideo";
    AttachmentType[AttachmentType["AgentVideoClip"] = 99] = "AgentVideoClip";
    AttachmentType[AttachmentType["StockVideo"] = 100] = "StockVideo";
})(AttachmentType || (AttachmentType = {}));
/** CoStar.Attachment.Entities.MapAttachmentType */
export var MapAttachmentType;
(function (MapAttachmentType) {
    MapAttachmentType[MapAttachmentType["Unknown"] = 0] = "Unknown";
    MapAttachmentType[MapAttachmentType["Property"] = 1] = "Property";
    MapAttachmentType[MapAttachmentType["Submarket"] = 2] = "Submarket";
    MapAttachmentType[MapAttachmentType["ResearchMarket"] = 3] = "ResearchMarket";
    MapAttachmentType[MapAttachmentType["PropertyAerial"] = 4] = "PropertyAerial";
    MapAttachmentType[MapAttachmentType["BoundingBox"] = 5] = "BoundingBox";
    MapAttachmentType[MapAttachmentType["Panorama"] = 6] = "Panorama";
    /** @deprecated Please use one of the other values, but pass a MapAttachmentShapeType instead. */
    MapAttachmentType[MapAttachmentType["PolygonParcel"] = 7] = "PolygonParcel";
    /** @deprecated Please use one of the other values, but pass a MapAttachmentShapeType instead. */
    MapAttachmentType[MapAttachmentType["PolygonParcelSatellite"] = 8] = "PolygonParcelSatellite";
})(MapAttachmentType || (MapAttachmentType = {}));
/** CoStar.Attachment.Entities.FileExtension */
export var FileExtension;
(function (FileExtension) {
    FileExtension[FileExtension["Unknown"] = 0] = "Unknown";
    FileExtension[FileExtension["Bmp"] = 1] = "Bmp";
    FileExtension[FileExtension["Csv"] = 2] = "Csv";
    FileExtension[FileExtension["Doc"] = 3] = "Doc";
    FileExtension[FileExtension["Gif"] = 4] = "Gif";
    FileExtension[FileExtension["Htm"] = 5] = "Htm";
    FileExtension[FileExtension["Jpg"] = 6] = "Jpg";
    FileExtension[FileExtension["Msg"] = 7] = "Msg";
    FileExtension[FileExtension["Pdf"] = 8] = "Pdf";
    FileExtension[FileExtension["Png"] = 9] = "Png";
    FileExtension[FileExtension["Rtf"] = 10] = "Rtf";
    FileExtension[FileExtension["Tif"] = 11] = "Tif";
    FileExtension[FileExtension["Txt"] = 12] = "Txt";
    FileExtension[FileExtension["Xls"] = 13] = "Xls";
    FileExtension[FileExtension["Invalid"] = 14] = "Invalid";
    FileExtension[FileExtension["Ppt"] = 15] = "Ppt";
    FileExtension[FileExtension["Arg"] = 16] = "Arg";
    FileExtension[FileExtension["Ipx"] = 17] = "Ipx";
    FileExtension[FileExtension["Mov"] = 18] = "Mov";
    FileExtension[FileExtension["Bak"] = 19] = "Bak";
    FileExtension[FileExtension["Bat"] = 20] = "Bat";
    FileExtension[FileExtension["Cal"] = 21] = "Cal";
    FileExtension[FileExtension["Cri"] = 22] = "Cri";
    FileExtension[FileExtension["Dat"] = 23] = "Dat";
    FileExtension[FileExtension["Dbf"] = 24] = "Dbf";
    FileExtension[FileExtension["Dbt"] = 25] = "Dbt";
    FileExtension[FileExtension["Eps"] = 26] = "Eps";
    FileExtension[FileExtension["Eqy"] = 27] = "Eqy";
    FileExtension[FileExtension["Err"] = 28] = "Err";
    FileExtension[FileExtension["Exe"] = 29] = "Exe";
    FileExtension[FileExtension["Fxp"] = 30] = "Fxp";
    FileExtension[FileExtension["Htt"] = 31] = "Htt";
    FileExtension[FileExtension["Iax"] = 32] = "Iax";
    FileExtension[FileExtension["Idx"] = 33] = "Idx";
    FileExtension[FileExtension["Ind"] = 34] = "Ind";
    FileExtension[FileExtension["Isx"] = 35] = "Isx";
    FileExtension[FileExtension["Jbf"] = 36] = "Jbf";
    FileExtension[FileExtension["Ldb"] = 37] = "Ldb";
    FileExtension[FileExtension["Lnk"] = 38] = "Lnk";
    FileExtension[FileExtension["Log"] = 39] = "Log";
    FileExtension[FileExtension["Map"] = 40] = "Map";
    FileExtension[FileExtension["Mdb"] = 41] = "Mdb";
    FileExtension[FileExtension["Mid"] = 42] = "Mid";
    FileExtension[FileExtension["Mif"] = 43] = "Mif";
    FileExtension[FileExtension["Ntx"] = 44] = "Ntx";
    FileExtension[FileExtension["Psd"] = 45] = "Psd";
    FileExtension[FileExtension["Sav"] = 46] = "Sav";
    FileExtension[FileExtension["Tab"] = 47] = "Tab";
    FileExtension[FileExtension["Td4"] = 48] = "Td4";
    FileExtension[FileExtension["Tdo"] = 49] = "Tdo";
    FileExtension[FileExtension["Wor"] = 50] = "Wor";
    FileExtension[FileExtension["Docx"] = 51] = "Docx";
    FileExtension[FileExtension["Svg"] = 52] = "Svg";
    FileExtension[FileExtension["Mpeg4"] = 53] = "Mpeg4";
    FileExtension[FileExtension["Mp4"] = 53] = "Mp4";
    FileExtension[FileExtension["Mp3"] = 54] = "Mp3";
    FileExtension[FileExtension["Wav"] = 55] = "Wav";
    FileExtension[FileExtension["Xlsx"] = 56] = "Xlsx";
    FileExtension[FileExtension["Pptx"] = 57] = "Pptx";
    FileExtension[FileExtension["Prprod"] = 58] = "Prprod";
    FileExtension[FileExtension["Prproj"] = 59] = "Prproj";
    FileExtension[FileExtension["Aep"] = 60] = "Aep";
    FileExtension[FileExtension["Xlsm"] = 61] = "Xlsm";
    FileExtension[FileExtension["Eml"] = 62] = "Eml";
})(FileExtension || (FileExtension = {}));
/** CoStar.Attachment.Entities.AttachmentEntityType */
export var AttachmentEntityType;
(function (AttachmentEntityType) {
    AttachmentEntityType[AttachmentEntityType["CondoUnit"] = 0] = "CondoUnit";
    AttachmentEntityType[AttachmentEntityType["Contact"] = 1] = "Contact";
    AttachmentEntityType[AttachmentEntityType["Contract"] = 2] = "Contract";
    AttachmentEntityType[AttachmentEntityType["ForSale"] = 3] = "ForSale";
    AttachmentEntityType[AttachmentEntityType["Land"] = 4] = "Land";
    AttachmentEntityType[AttachmentEntityType["Location"] = 5] = "Location";
    /** @deprecated Please use 'Location' instead. */
    AttachmentEntityType[AttachmentEntityType["Company"] = 5] = "Company";
    AttachmentEntityType[AttachmentEntityType["Property"] = 6] = "Property";
    AttachmentEntityType[AttachmentEntityType["SpaceForLease"] = 7] = "SpaceForLease";
    AttachmentEntityType[AttachmentEntityType["SpaceOccupied"] = 8] = "SpaceOccupied";
    AttachmentEntityType[AttachmentEntityType["Submarket"] = 9] = "Submarket";
    AttachmentEntityType[AttachmentEntityType["SaleComp"] = 10] = "SaleComp";
    AttachmentEntityType[AttachmentEntityType["SaleCompDocument"] = 11] = "SaleCompDocument";
    AttachmentEntityType[AttachmentEntityType["ShoppingCenter"] = 12] = "ShoppingCenter";
    AttachmentEntityType[AttachmentEntityType["LeaseDeal"] = 13] = "LeaseDeal";
    AttachmentEntityType[AttachmentEntityType["LandForLease"] = 14] = "LandForLease";
    AttachmentEntityType[AttachmentEntityType["Loan"] = 15] = "Loan";
    AttachmentEntityType[AttachmentEntityType["ContactActivity"] = 16] = "ContactActivity";
    AttachmentEntityType[AttachmentEntityType["ApartmentModel"] = 17] = "ApartmentModel";
    AttachmentEntityType[AttachmentEntityType["PropertyResidential"] = 18] = "PropertyResidential";
    AttachmentEntityType[AttachmentEntityType["ApartmentUnit"] = 19] = "ApartmentUnit";
    AttachmentEntityType[AttachmentEntityType["Article"] = 20] = "Article";
    AttachmentEntityType[AttachmentEntityType["Intermediate"] = 21] = "Intermediate";
    AttachmentEntityType[AttachmentEntityType["Listing"] = 22] = "Listing";
    AttachmentEntityType[AttachmentEntityType["College"] = 23] = "College";
    AttachmentEntityType[AttachmentEntityType["WorkspaceType"] = 24] = "WorkspaceType";
    AttachmentEntityType[AttachmentEntityType["ListingNote"] = 25] = "ListingNote";
    AttachmentEntityType[AttachmentEntityType["Workspace"] = 26] = "Workspace";
    AttachmentEntityType[AttachmentEntityType["CommercialListing"] = 27] = "CommercialListing";
    AttachmentEntityType[AttachmentEntityType["ListingRestricted"] = 28] = "ListingRestricted";
    AttachmentEntityType[AttachmentEntityType["Corporation"] = 29] = "Corporation";
    AttachmentEntityType[AttachmentEntityType["Neighborhood"] = 30] = "Neighborhood";
    AttachmentEntityType[AttachmentEntityType["Park"] = 31] = "Park";
    AttachmentEntityType[AttachmentEntityType["School"] = 32] = "School";
    /** @deprecated Please use 'Listing' instead. */
    AttachmentEntityType[AttachmentEntityType["SyntheticListing"] = 103] = "SyntheticListing";
    AttachmentEntityType[AttachmentEntityType["Tenant"] = 105] = "Tenant";
    AttachmentEntityType[AttachmentEntityType["Unknown"] = -1] = "Unknown";
})(AttachmentEntityType || (AttachmentEntityType = {}));
/** CoStar.Attachment.Entities.MapAttachmentShapeType */
export var MapAttachmentShapeType;
(function (MapAttachmentShapeType) {
    MapAttachmentShapeType[MapAttachmentShapeType["Unknown"] = 0] = "Unknown";
    MapAttachmentShapeType[MapAttachmentShapeType["Parcel"] = 1] = "Parcel";
})(MapAttachmentShapeType || (MapAttachmentShapeType = {}));
/** CoStar.Attachment.Entities.PushpinStyle */
export var PushpinStyle;
(function (PushpinStyle) {
    PushpinStyle[PushpinStyle["Default"] = 0] = "Default";
    PushpinStyle[PushpinStyle["Hidden"] = 1] = "Hidden";
    PushpinStyle[PushpinStyle["Alternative1"] = 2] = "Alternative1";
})(PushpinStyle || (PushpinStyle = {}));
/** CoStar.Attachment.Entities.AttachmentSource */
export var AttachmentSource;
(function (AttachmentSource) {
    AttachmentSource[AttachmentSource["Unknown"] = 0] = "Unknown";
    AttachmentSource[AttachmentSource["Conversion"] = 1] = "Conversion";
    AttachmentSource[AttachmentSource["FieldResearch"] = 2] = "FieldResearch";
    AttachmentSource[AttachmentSource["Broker"] = 3] = "Broker";
    AttachmentSource[AttachmentSource["Owner"] = 4] = "Owner";
    AttachmentSource[AttachmentSource["PropertyManager"] = 5] = "PropertyManager";
    AttachmentSource[AttachmentSource["Other"] = 6] = "Other";
    AttachmentSource[AttachmentSource["DataTree"] = 7] = "DataTree";
    AttachmentSource[AttachmentSource["PublicRecord"] = 8] = "PublicRecord";
    AttachmentSource[AttachmentSource["LoopNet"] = 9] = "LoopNet";
    AttachmentSource[AttachmentSource["ApartmentsFieldResearch"] = 10] = "ApartmentsFieldResearch";
    AttachmentSource[AttachmentSource["ApartmentsFeed"] = 11] = "ApartmentsFeed";
    AttachmentSource[AttachmentSource["RentalHomesPlus"] = 12] = "RentalHomesPlus";
    AttachmentSource[AttachmentSource["InboundPropertyPlatform"] = 13] = "InboundPropertyPlatform";
    AttachmentSource[AttachmentSource["ListHub"] = 14] = "ListHub";
    AttachmentSource[AttachmentSource["ApartmentsNetworkUser"] = 15] = "ApartmentsNetworkUser";
    AttachmentSource[AttachmentSource["Matterport"] = 16] = "Matterport";
    AttachmentSource[AttachmentSource["Waypoint"] = 17] = "Waypoint";
    AttachmentSource[AttachmentSource["ApartmentFinderUser"] = 18] = "ApartmentFinderUser";
    AttachmentSource[AttachmentSource["ExtendedStayAmerica"] = 19] = "ExtendedStayAmerica";
    AttachmentSource[AttachmentSource["UserEntered"] = 20] = "UserEntered";
    AttachmentSource[AttachmentSource["LoopNetFeed"] = 21] = "LoopNetFeed";
    AttachmentSource[AttachmentSource["WestsideRentals"] = 22] = "WestsideRentals";
    AttachmentSource[AttachmentSource["ForRent"] = 23] = "ForRent";
    AttachmentSource[AttachmentSource["Emporis"] = 24] = "Emporis";
    AttachmentSource[AttachmentSource["CaseManagement"] = 25] = "CaseManagement";
})(AttachmentSource || (AttachmentSource = {}));
